module.exports = __webpack_public_path__ + "img/verkaufstraining.3b863f6f.jpg";